import React, { useEffect } from "react"
import i18n from "@/i18n"

type InterstitialMode = "loading" | "celebrate" | "hide" | null

type Props = {
  mode: NonNullable<InterstitialMode>
  onDismiss: () => void
  onExited: () => void
}

const ConfirmationInterstitial: React.FC<Props> = ({ mode, onDismiss, onExited }) => {
  useEffect(() => {
    if (mode === "hide") {
      onExited()
    }
  }, [mode, onExited])

  if (mode === "hide") return null

  return (
    <div data-testid="confirmation-interstitial" data-mode={mode}>
      {mode === "celebrate" && (
        <button onClick={onDismiss} data-testid="interstitial-dismiss">
          {i18n.t("app.public.reservation.confirmation_interstitial.dismiss")}
        </button>
      )}
    </div>
  )
}

export default ConfirmationInterstitial
